import {OTP_VERIFY} from "../../actions";
import http from "../../../service"
import {otp_verify} from "../../../endPoints";

export const otpVerified = (msisdn, secret_key) => {
    console.log(msisdn, secret_key);
    return async dispatch => {
        const data = await http.postWebApiWithBody(
            otp_verify,
            {
                "msisdn": msisdn,
                "secret_key": secret_key

            },
        );
        dispatch({type: OTP_VERIFY, payload: data})
    };
};